module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.18.1@axios/index.js
// module id = 541
// module chunks = 2 3